<template>
<div id="page-perfiles" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Administrar Perfiles" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>
                     
                        <exportar-excel :data="perfiles.items" :exportFields="camposexcelperfiles" name="Lista Perfiles.xlsx" >
                            <v-btn x-small fab dark color="success" title="Exportar" v-tippy>
                                <v-icon dark>get_app</v-icon>
                            </v-btn>
                        </exportar-excel>
                        <v-btn fab dark x-small color="secondary" slot="activator" @click.native="getPermisosPerfil(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>

                        <v-dialog v-model="model_modulos" max-width="50%" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" >edit</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>Actualizar Perfil</strong>
                                        </span>
                                    </v-card>
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click.native="modal = false" class="close_modal" >
                                        <v-icon class="white--text" >cancel</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-form ref="form" lazy-validation>
                                    <v-card-text>
                                        
                                        <v-card-title>
                                            <span class="subheading primary--text" >Módulos</span>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-data-table :headers="modulos.headers" :items="modulos.items" class="elevation-1" v-model="modulos.selected" item-key="id_modulo" show-select>
                                                <template slot="items" slot-scope="modulos" >
                                                    <tr>
                                                        <td>
                                                            <v-checkbox v-model="modulos.selected" primary hide-details></v-checkbox>
                                                        </td>
                                                        <td>{{ modulos.item.nombre }}</td>
                                                    </tr>
                                                </template>
                                            </v-data-table>
                                        </v-card-text>
                                    </v-card-text>
                                </v-form>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="model_modulos = false" >
                                        <v-icon>cancel</v-icon> Cancelar
                                    </v-btn>
                                    <v-btn color="success" @click.native="updateModulos(model.id_perfil)" >
                                        <v-icon>done</v-icon> Actualizar
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="modal" max-width="50%" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon @click.native="modal = false" class="white--text" >cancel</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>{{ update ? "Actualizar" : "Nuevo" }} Perfil</strong>
                                        </span>
                                    </v-card>
                                    
                                    <v-btn icon @click.native="modal = false" class="close_modal" >
                                        <v-icon class="white--text" >cancel</v-icon>
                                    </v-btn>
                                </v-card-title>
                                

                                
                                <v-card-text>
                               
                                    <v-container grid-list-md>
                                        <v-layout wrap>
                                            <v-flex xs12>
                                                <v-text-field label="Nombre" v-model="model.nombre" required></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                    <v-card-text>
                                        <v-app-bar color="white" >
                                            <v-layout wrap>
                                                <v-flex xs6>
                                                    <v-select clearable :items="permisos.items" v-model="searchpermisos" label="Modulos del Sistema" item-text="modulo" item-value="modulo" single-line></v-select>
                                                </v-flex>
                                                <v-flex xs6>
                                                    <v-text-field text prepend-icon="search" placeholder="Buscar" v-model="searchpermisos" hide-details class="hidden-sm-and-down" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-app-bar>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <exportar-excel :data="permisos.items" :exportFields="camposexcel" name="Lista Permisos.xlsx" >
                                                <v-btn x-small fab dark color="success" title="Exportar Permisos" v-tippy>
                                                    <v-icon dark>get_app</v-icon>
                                                </v-btn>
                                            </exportar-excel>
                                        </v-card-actions>
                                        <v-data-table hide-default-footer :items-per-page="100" :headers="permisos.headers" :search="searchpermisos" :items="permisos.items" class="elevation-1" v-model="permisos.selected" item-key="id_permiso" show-select>
                                            <template slot="no-data" >
                                                <v-alert :value="true" color="error" icon="warning" >
                                                    No hay datos...
                                                </v-alert>
                                            </template>

                                            <template slot="items" slot-scope="permisos" >
                                                <tr>
                                                    <td>
                                                        <v-checkbox v-model="permisos.selected" primary hide-details></v-checkbox>
                                                    </td>
                                                    <td>{{ permisos.item.modulo }}</td>
                                                    <td>{{ permisos.item.categoria }}</td>
                                                    <td>{{ permisos.item.nombre }}</td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-card-text>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click.native="modal = false" >Cancelar</v-btn>
                                    <v-btn color="blue darken-1" text v-if="update" @click.native="updatePerfil(model.id_perfil)" >Actualizar</v-btn>
                                    <v-btn color="blue darken-1" text v-if="!update" @click.native="savePerfil()" >Guardar</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >

                            <v-client-table ref="vuetable" :data="perfiles.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="blue" @click.native="getPerfil(props.row.id_perfil)" title="Editar Perfil" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="green" @click.native="getModulos(props.row.id_perfil)" title="Editar Módulos" v-tippy>
                                            <v-icon>mdi-table-column-plus-after</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="deletePerfil(props.row.id_perfil)" title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";

export default {
    created: function () {
        this.model.cliente = this.$local_storage.get("id_cliente");
        this.getPerfiles();
       
    },

    data() {
        return {
            fab: false,
            camposexcel: {
                Clave: "clave",
                Modulo: "modulo",
                Categoria: "categoria",
                Nombre: "nombre",
            },
            camposexcelperfiles: {
                Nombre: "nombre",
            },
            model_modulos: false,
            modulos: {
                selected: [],
                headers: [{
                    text: "Nombre",
                    value: "nombre"
                }, ],
                items: [],
                todos: []
            },
            searchpermisosselect: '',
            name: "datagrid",
            columns: ["nombre", "actions"],
            show_loading: true,
            options: {
                filterable: ["nombre"],
                sortable: ["nombre"],

                headings: {
                    nombre: "Nombre",
                    actions: "Operaciones"
                },
                pagination: {
                    //sortBy: ['modulo', 'categoria'] //TOTAVIA NO ORDENA POR MULTIPLES COLUMNAS,
                    //HASTA QUE SE AGREGUE A LAS NUEVAS VERSIONES DE VUETIFY
                    sortBy: "ordenar"
                },
            },
            show_loading: true,
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/admin"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    href: ""
                },
                {
                    text: "Administrar Perfiles",
                    disabled: true,
                    href: ""
                }
            ],
            title: "",
            modal: false,
            update: false,
            model: {
                nombre: "",
                id_perfil: 0,
                sistema: this.$sistema,
                cliente: 0,
                permisos: []
            },
            search: "",
            searchpermisos: "",
            perfiles: {
                selected: [],
                headers: [{
                        text: "Nombre",
                        value: "nombre",
                        width: "70%"
                    },
                    {
                        text: "Operaciones",
                        value: "operaciones",
                        align: "center"
                    }
                ],
                items: []
            },

            permisos: {
                selected: [],
                headers: [{
                        text: "Modulo",
                        value: "modulo",
                        width: "20%"
                    },
                    {
                        text: "Categoría",
                        value: "categoria",
                        width: "30%"
                    },
                    {
                        text: "Permiso",
                        value: "nombre",
                        width: "60%"
                    }
                ],
                /*items: [

{id_permiso:1,categoria:"Catálogos",nombre:"Permiso 1",activo:1},

{id_permiso:2,categoria:"Catálogos",nombre:"Permiso 2",activo:1},

{id_permiso:3,categoria:"Administración",nombre:"Permiso 3",activo:0},

{id_permiso:4,categoria:"Administración",nombre:"Permiso 4",activo:1},

{id_permiso:5,categoria:"Reportes",nombre:"Permiso 5",activo:0},

]*/
                items: [0]
            }
        };
    },

    methods: {
    
        openModal: function (type) {
            if (type === 1) {
                this.title = "Nuevo Perfil";
                this.update = false;
                this.model.nombre = "";
                this.model.id_perfil = 0;
            } else {
                this.title = "Actualizar Perfil";
                this.update = true;
            }
            this.searchpermisos = "";
            this.modal = true;
        },
        getModulos: function (perfil) {
            this.model.id_perfil = perfil;
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.modulos.selected = [];
            this.model_modulos = true
            let data = {
                "perfil":perfil
            }
            axios
                .post(this.$hostname + "perfiles/get_modulos_perfil/", data)
                .then(response => {
                    this.modulos.items = response.data;
                    this.modulos.todos = response.data;
                   
                    response.data.forEach(element => {
                        if (element.acceso== 1 )
                            this.modulos.selected.push(element);
                    });
                   this.$root.$dialogLoader.hide();
                     
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los modulos.",
                        footer: ""
                    });
                });
        },
        getPermisosPerfil: function (type) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .post(this.$hostname + "perfiles/get_permisos_perfil/", this.model)
                .then(response => {
                    this.permisos.items = response.data;
                    this.permisos.selected = [];
                    var arr = response.data;

                    for (var i in arr) {
                        if (arr[i].activo == 1)
                            this.permisos.selected.push(arr[i]);
                    }

                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los permisos.",
                        footer: ""
                    });
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.openModal(type);
                });
        },

        llenaModelPermisos: function () {
            this.model.permisos = [];
            var arr = this.permisos.selected;
            for (var i in arr) {
                this.model.permisos.push(arr[i].id_permiso);
            }
        },

        getPerfiles: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                sistema: this.$sistema
            };

            axios
                .get(this.$hostname + "perfiles/")
                .then(response => {
                    this.perfiles.items = response.data;
                    this.$root.$dialogLoader.hide();
                })
                .catch(error => {
                    this.$root.$dialogLoader.hide();
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los perfiles.",
                        footer: ""
                    });
                });
        },

        savePerfil: function () {
            if (this.model.nombre == "") {
                this.$swal({
                    type: "info",
                    title: "Cuidado",
                    text: "Tiene que ingresar el nombre del perfil.",
                    footer: ""
                });
            } else if (Object.keys(this.permisos.selected).length <= 0) {
                this.$swal({
                    type: "info",
                    title: "Cuidado",
                    text: "Tiene que seleccionar al menos un permiso para el perfil.",
                    footer: ""
                });
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                this.llenaModelPermisos();
                axios
                    .post(this.$hostname + "perfiles/", this.model)
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El perfil se creó correctamente.",
                            footer: ""
                        });
                        this.modal = false;
                        this.getPerfiles();
                    })
                    .catch(error => {
                        console.log(error);
                        this.$root.$dialogLoader.hide();
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar el perfil",
                            footer: ""
                        });
                    });
            }
        },

        getPerfil: function (id_perfil) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.$hostname + "perfiles/" + id_perfil + "/")
                .then(response => {
                    this.model.nombre = response.data.nombre;
                    this.model.id_perfil = response.data.id_perfil;
                    this.getPermisosPerfil(2); //2-Actualizar
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el perfil",
                        footer: ""
                    });
                    this.$root.$dialogLoader.hide();
                });
        },

        updatePerfil: function () {
            let id_perfil = this.model.id_perfil;
            this.llenaModelPermisos();
            if (this.model.nombre == "") {
                this.$swal({
                    type: "info",
                    title: "Cuidado",
                    text: "Tiene que ingresar el nombre del perfil.",
                    footer: ""
                });
            } else if (Object.keys(this.permisos.selected).length <= 0) {
                this.$swal({
                    type: "info",
                    title: "Cuidado",
                    text: "Tiene que seleccionar al menos un permiso para el perfil.",
                    footer: ""
                });
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                axios
                    .put(this.$hostname + "perfiles/" + id_perfil + "/", this.model)
                    .then(response => {
                        this.updatePermisosPerfil();
                    })
                    .catch(error => {
                        console.log(error);
                        let msj = error.response.data.detail;

                        console.log(msj);

                        if (msj === undefined) msj = error.response.data.nombre;
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: msj,
                            footer: ""
                        });
                        this.$root.$dialogLoader.hide();
                    });
            }
        },
        updateModulos: function (perfil) {
            let m = [];
            this.modulos.selected.forEach(element => {
                m.push(element.id_modulo);
            });
            var datos = {
                id_perfil: perfil,
                modulos: m
            };
            axios
                .post(this.$hostname + "perfiles/set_modulos_perfil/", datos)
                .then(response => {
                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "El perfil se actualizó correctamente.",
                        footer: ""
                    });

                    this.model_modulos = false;
                })
                .catch(error => {
                    console.log(error);
                    let msj = error.response.data.detail;

                    console.log(msj);

                    if (msj === undefined) msj = error.response.data.nombre;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: msj,
                        footer: ""
                    });
                    this.$root.$dialogLoader.hide();
                });
        },

        updatePermisosPerfil: function () {
            let perfil = this.model.id_perfil;
            var datos = {
                perfil: perfil,
                permisos: this.model.permisos
            };
            axios
                .post(this.$hostname + "perfiles/add_permisos_perfil/", datos)
                .then(response => {
                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "El perfil se actualizó correctamente.",
                        footer: ""
                    });
                    this.getPerfiles();
                    this.modal = false;
                })
                .catch(error => {
                    console.log(error);
                    let msj = error.response.data.detail;

                    console.log(msj);

                    if (msj === undefined) msj = error.response.data.nombre;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: msj,
                        footer: ""
                    });
                    this.$root.$dialogLoader.hide();
                });
        },

        deletePerfil: function (id_perfil) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios
                        .delete(this.$hostname + "perfiles/" + id_perfil + "/")
                        .then(response => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El registro se eliminó correctamente.",
                                footer: ""
                            });
                            this.getPerfiles();
                        })
                        .catch(error => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro",
                                footer: ""
                            });
                        }).then(() => {
                            this.$root.$dialogLoader.hide();
                        });
                }

            });
        }
    }
};
</script>
